module.exports = __webpack_public_path__ + "img/user-circle.05b4fac9.svg";